module.exports = __webpack_public_path__ + "img/EDC8601_R.de48e26c.png";